export default __webpack_public_path__ + "static/media/860.6cbd9ef4.png";